import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NouisliderModule } from 'ng2-nouislider';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { SharedModule } from '../_shared/shared.module';
import { AllFilterSheetComponent } from './component/all-filter-sheet/all-filter-sheet.component';
import { PropertyFilterBarComponent } from './component/property-filter-bar/property-filter-bar.component';

export const options: Partial<IConfig> = {
  thousandSeparator: ',',
};

@NgModule({
  declarations: [PropertyFilterBarComponent, AllFilterSheetComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatInputModule,
    MatSidenavModule,
    MatButtonModule,
    MatCheckboxModule,
    FormsModule,
    MatDatepickerModule,
    MatChipsModule,
    SharedModule,
    NouisliderModule,
    MatSlideToggleModule,
    NgxMaskModule.forRoot(options),
  ],
  exports: [PropertyFilterBarComponent, AllFilterSheetComponent],
})
export class PropertyFilterModule {}
